/** 笛卡尔向量。黄道 J2000：x 指向春分点，z 指向黄道北，右手系，单位 AU（除非另行说明）。 */
export interface Vec3 { x: number; y: number; z: number }

export const AU_KM = 149597870.7;

export const add = (a: Vec3, b: Vec3): Vec3 => ({ x: a.x + b.x, y: a.y + b.y, z: a.z + b.z });
export const sub = (a: Vec3, b: Vec3): Vec3 => ({ x: a.x - b.x, y: a.y - b.y, z: a.z - b.z });
export const norm = (a: Vec3): number => Math.hypot(a.x, a.y, a.z);
export const dot = (a: Vec3, b: Vec3): number => a.x * b.x + a.y * b.y + a.z * b.z;

/** 两向量夹角（弧度）。 */
export function angleBetween(a: Vec3, b: Vec3): number {
  // 用 atan2(|a×b|, a·b) 保证小角度数值稳定
  const cx = a.y * b.z - a.z * b.y, cy = a.z * b.x - a.x * b.z, cz = a.x * b.y - a.y * b.x;
  return Math.atan2(Math.hypot(cx, cy, cz), dot(a, b));
}

/**
 * 黄道 J2000 → 渲染场景坐标（y 向上的右手系）：
 * scene = (x_ecl, z_ecl, −y_ecl)。黄道面成为 XZ 平面，黄道北为 +Y。
 */
export function eclToScene(v: Vec3): [number, number, number] {
  return [v.x, v.z, -v.y];
}
